<template>
  <div class="wrapper" :style={width,height}>
    <svg data-name="Livello 1" id="Livello_1" viewBox="0 0 24 38" :width="width" :height="height" :style="{transform: `rotate(${rotation}deg)`}">
      <polyline
        class="polygon"
        :stroke="stroke"
        points="18 2 2 18 18 36"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'arrow',
  props: {
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
    stroke: {
      type: String,
      default: '#ffffff',
    },
    rotation: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
svg {
  transition: all 0.3s;
}
.polygon {
  fill:none;
  stroke-linecap:round;
  stroke-linejoin:round;
  stroke-width:4px;
  transition: all 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/holiday/calendar/components/Arrow.vue